import { render, staticRenderFns } from "./BCA.vue?vue&type=template&id=197c618e&"
import script from "./BCA.vue?vue&type=script&lang=js&"
export * from "./BCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports